import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'geoCoworkings' as const;

/**
 * Тег коворкинга (jsonQuery.coworking_id).
 * Сервер не отдаёт гео-тег коворкинга, поэтому имя берётся из локально
 * сохранённых имён (coworkingNames), выбранных в саджесте, иначе — фолбэк.
 */
export const geoCoworkingsTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, coworkingNames }) => {
    const ids = getTermsValue('coworking_id')(jsonQuery);

    if (ids === null) {
      return null;
    }

    return ids.map(id => ({
      label: coworkingNames?.[id] || `Коворкинг №${id}`,
      value: createTagValue(ID, id.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const ids = getTermsValue('coworking_id')(jsonQuery);

    if (ids === null) {
      return jsonQuery;
    }

    const filteredIds = ids.filter(id => String(id) !== removingTagValue);

    return filteredIds.length
      ? setTerms('coworking_id')(jsonQuery)(filteredIds)
      : resetTerms(['coworking_id'])(jsonQuery);
  },
};
